import { render, staticRenderFns } from "./GooglePayment.vue?vue&type=template&id=af6e29a2&"
import script from "./GooglePayment.vue?vue&type=script&lang=js&"
export * from "./GooglePayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports